module.exports = __webpack_public_path__ + "static/media/relationships@2x.a773eadb.png";